<template>
  <div class="app-mnp-in-provider">
    <fieldset label="Anbieter" label-class="visually-hidden" class="inputs-container">
      <div class="input-field">
        <label class="text-base-medium" for="msisdn">
          Dein bisheriger Anbieter:<span class="required" aria-hidden="true">*</span>
        </label>
        <select id="provider" class="input" v-model="selectedKeys_" @input="$v.selectedKeys.$touch">
          <option value="default" disabled>
            Wählen Sie Ihren bisherigen Anbieter aus
          </option>
          <option v-for="provider in filteredProviders" :key="provider.key" :value="provider">
            {{ provider.brandName }} ({{ provider.networkKey }})
          </option>
        </select>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import syncProperty from '@/mixins/syncProperty'
import { required } from 'vuelidate/lib/validators'
import isValid from '@/mixins/isValid'
import { validationMixin } from 'vuelidate'
import { mapGetters } from 'vuex'

export default {
  name: 'ProviderList',
  props: {},
  data() {
    return {
      allMnpProviders: {},
      selectedProvider: null
    }
  },
  computed: {
    providerDefaultOption: function() {
      return [
        {
          value: 'default',
          text: 'Wählen Sie Ihren bisherigen Anbieter aus'
        }
      ]
    },
    providerOptions: function() {
      if (this.allMnpProviders?.mnpProviders === null) {
        return []
      }
      return this.allMnpProviders?.mnpProviders
        ?.reduce((all, provider) => {
          return all.concat(
            provider.networks.map(network => {
              return {
                networkKey: network.key,
                providerKey: provider.key,
                networkName: network.name,
                providerName: provider.name
              }
            })
          )
        }, [])
        .map(provider => {
          return {
            value: {
              networkKey: provider.networkKey,
              providerKey: provider.providerKey
            },
            text: provider.providerName + ' (' + provider.networkName + ')'
          }
        })
    },
    providerWithDefaultOptions: function() {
      return this.providerDefaultOption.concat(this.providerOptions)
    },
    newProviderWithDefaultOptions: function() {
      return this.providerDefaultOption.concat(this.newProviderOptions)
    },
    filteredProviders: function() {
      if (this.allMnpProviders.mnpProvidersWithTariffs) {
        return this.allMnpProviders.mnpProvidersWithTariffs
          .map(provider => {
            if (provider.mnpProvidersWithTariffs) {
            }
            const priorityOneProviders = provider.mnpProvidersWithTariffs.filter(
              tariff => tariff.availableForPorting && tariff.priority === 1
            )
            return priorityOneProviders.flatMap(tariff => {
              if (tariff.networks && tariff.networks.key) {
                return tariff.networks.key.map(network => ({
                  brandName: provider.brandName,
                  key: tariff.key + '_' + network,
                  providerKey: tariff.key,
                  networkKey: network
                }))
              }
              return []
            })
          })
          .flat()
      } else {
        return []
      }
    },
    ...mapGetters(['brand'])
  },
  watch: {
    '$v.$invalid': function(newValue) {
      this.$emit('update:invalid', newValue)
    }
  },
  mounted() {
    this.$emit('update:invalid', this.$v.$invalid)
  },
  mixins: [isValid, validationMixin, syncProperty('selectedKeys', 'selectedKeys_')],
  apollo: {
    mnpProvider: function() {
      return wrapQuery(
        gql`
          query mnpIn($brand: String!) {
            allMnpProviders {
              mnpProvidersWithTariffs(brand: $brand, condensed: false) {
                brandName
                mnpProvidersWithTariffs {
                  availableForPorting
                  code
                  contractPartner
                  key
                  networks {
                    key
                  }
                  priority
                }
              }
            }
          }
        `,
        this,
        'allMnpProviders',
        { brand: this.brand },
        () => {},
        { fetchPolicy: 'cache-first' }
      )
    }
  },
  validations() {
    return {
      selectedKeys: {
        required,
        validSelectedKeys: selectedKeys_ => {
          return selectedKeys_ !== 'default'
        }
      }
    }
  }
}
</script>
